import { useState } from "react";
import { CircularProgress, InputAdornment, OutlinedInput, Stack, Typography } from "@mui/material";
import React from "react";
import { ThumbnailSize } from "../../../Core/Api/Thumbnail/thumbnail-api-service";
import { cacheService, rightService, thumbnailService } from "../../../Core/Api/services";
import { handleSelectClickObject, isItemSelectedObject } from "../../../Utils/Helpers/selectMode";
import ListPageHeader, { ListPageHeaderLeft, ListPageHeaderRight } from "../../../Components/Misc/ListPageHeader";
import MovieCard, { MovieCardGrid, MovieCardProps } from "../../../Components/Cards/MovieCard/movie-card";
import SearchIcon from "@mui/icons-material/Search";
import { GetMetadataByTagName } from "../../../Core/Utils/asset-object-utils";
import { DbMetadataFieldInfos } from "../../../Core/Api/Types/db-metadata-field-infos";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { useTranslation } from "react-i18next";

function Contract() {
    const { t } = useTranslation();
    const maxItems = 15;
    const [selectedTitles, setSelectedTitles] = useState<DbAssetObjectInfos[]>([]);
    const [titles, setTitles] = React.useState<Omit<MovieCardProps, "index">[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [textFilter, setTextFilter] = React.useState<string>("");
    const thumbSize: ThumbnailSize = ThumbnailSize.medium;
    const metadata: DbMetadataFieldInfos[] = cacheService.GetMetadata();

    // Fetching data
    React.useEffect(() => {
        rightService.GetRightContracts(maxItems, metadata, true).then((response) => {
            const movieCardsData: Omit<MovieCardProps, "index">[] = response.map((title) => {
                const productionDate = title.titleInfos?.metadata?.find(
                    (x) => x.id === cacheService.GetMetadata().find((m) => m.tagName === "productionDate")?.id
                )?.value;
                return {
                    id: title.titleId || 0,
                    obj: title.titleInfos!,
                    to: "#",
                    cover: thumbnailService.GetObjectPosterUrl(title.titleId || 0, thumbSize),
                    title: title.titleInfos?.name || "",
                    labelList: [productionDate ? new Date(productionDate).getFullYear().toString() : "Unknown"],
                    quality: GetMetadataByTagName(title.titleInfos!, "titleType", metadata)?.value,
                    favorite: false,
                    expand: {
                        contentList: [],
                        audioList: [],
                        subtitleList: [],
                        tagList: [],
                        quality: "",
                    },
                    selectMode: true,
                    onSelectClick: handleSelectClickObject(selectedTitles, setSelectedTitles),
                };
            });

            setTitles(movieCardsData);
            setIsLoading(false);
        });
    }, []);

    return (
        <>
            <ListPageHeader mb={1}>
                <ListPageHeaderLeft>
                    {!isLoading && (
                        <Typography mb={2} variant="h5" color="text.primary">
                            {t("page:body.titlesWithCount", { count: titles.length })}
                        </Typography>
                    )}
                </ListPageHeaderLeft>
                <ListPageHeaderRight>
                    <OutlinedInput
                        label={t("common:search")}
                        placeholder={t("common:search")}
                        value={textFilter}
                        onChange={(e) => setTextFilter(e.currentTarget.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        }
                    />
                </ListPageHeaderRight>
            </ListPageHeader>

            {isLoading && (
                <CircularProgress
                    size={25}
                    sx={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                    }}
                />
            )}

            {!isLoading && (
                <Stack sx={(t) => ({ flex: "1 1 0", minHeight: "0", overflow: "scroll", ...t.helpers(t).scrollBar })}>
                    <MovieCardGrid sx={{ width: "100%" }}>
                        {titles
                            .filter((x) => textFilter === "" || x.title?.toLowerCase().includes(textFilter.toLowerCase()))
                            .map((movie, index) => (
                                <MovieCard
                                    selected={isItemSelectedObject(movie.obj!, selectedTitles)}
                                    selectedOnClick={selectedTitles.length > 0 ? true : false}
                                    {...movie}
                                    key={movie.id}
                                />
                            ))}
                    </MovieCardGrid>
                </Stack>
            )}
        </>
    );
}

export default Contract;
